import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookOpen, Utensils, Droplet, ShoppingCart, Activity, ShieldPlus } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-forest" data-id="element-154" />,
    title: 'El Protocolo Maestro de 14 Días',
    desc: 'Tu cronograma paso a paso (Día 1 al 14) para que sepas exactamente qué hacer desde que despiertas.'
  }, {
    icon: <Utensils className="w-8 h-8 text-forest" data-id="element-155" />,
    title: 'Recetario de 50 Platos de Rescate',
    desc: 'Desayunos, almuerzos, cenas y snacks diseñados para que comer vuelva a ser un placer sin miedo.'
  }, {
    icon: <Droplet className="w-8 h-8 text-forest" data-id="element-156" />,
    title: 'Guía de Hidratación Osmótica',
    desc: 'El secreto para limpiar tus filtros sin sobrecargarlos.'
  }, {
    icon: <ShoppingCart className="w-8 h-8 text-forest" data-id="element-157" />,
    title: 'Anexo Especial: Lista de Compras Antiestrés',
    desc: 'Ve al supermercado con una lista clara; sin confusión, sin perder tiempo.'
  }, {
    icon: <Activity className="w-8 h-8 text-forest" data-id="element-158" />,
    title: 'Diario de Monitoreo Renal',
    desc: 'Una herramienta práctica para que veas cómo la espuma de tu orina y tu energía cambian cada día.'
  }, {
    icon: <ShieldPlus className="w-8 h-8 text-forest" data-id="element-159" />,
    title: 'Manual de Suplementos Alternativos',
    desc: 'Los 4 aliados naturales para proteger tus nefronas.'
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-160">
      <div className="max-w-6xl mx-auto" data-id="element-161">
        <FadeIn data-id="element-162">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-forest" data-id="element-163">
            El Paquete Completo
          </h2>
        </FadeIn>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-164">
          <FadeIn delay={0.2} data-id="element-165">
            <div className="space-y-6" data-id="element-166">
              {items.map((item, idx) => <div key={idx} className="flex gap-4 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-167">
                  <div className="bg-green-50 p-4 rounded-xl shrink-0 h-fit" data-id="element-168">
                    {item.icon}
                  </div>
                  <div data-id="element-169">
                    <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-170">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-171">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-172">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-173">
              <img src="https://cdn.magicpatterns.com/uploads/w54PadVbhMpDixajpXc6fw/Protocolo_de_rescate_para_tus_rinones.png" alt="Tablet mostrando el protocolo, recetas y lista de compras" className="w-full h-auto object-cover" data-id="element-174" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}